import Styled from 'styled-components';

const ConversationContainer = Styled.div`
  // width: 100%;
  // backgorun-color:red;

  //  @media (max-width: 600px) {
  //   width: 100%;
  //   bottom: 0;
  // }
`;

const ConversationWrapper = Styled.div`
  padding: 0 10px;
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Heading = Styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
`;

const StyledNamearagraph = Styled.p`
  font-family: 'Roboto', sans-serif;
  font-weight: 600;
  font-size: 20px;
  margin: 0;
  letter-spacing: 5%;
  line-height: 0.8;
  @media (max-width: 600px) {
    font-size: 16px;
  }
`;

const StyledStatusParagraph = Styled.p`
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
  font-size: 14px;
  margin: 0;
  letter-spacing: 5%;
`;

const ConversationBox = Styled.div`
  margin-top: 15px;
  padding: 5px 10px;
  // box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.07);
`;

const StyledInput = Styled.input`
  border-radius: 9999px;
  border: 1px solid #d9d9d9;
  background-color: #eff6fc;
  width: 100%;
  height: 45px;
  padding: 0px 36px 0px 10px;
  font-weight: 500;
  color: black;

  ::placeholder {
    color: gray;
    font-weight: 400;
  }

  &:focus {
    outline: none;
    border-color: #4096ff; 
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }
`;

const StyledContainer = Styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  border-radius: 6px;
  justify-content: center;
  align-items: center;
`;

const StyledReponseParagraph = Styled.p`
  font-size: 18px;
  font-weight: 400;
  font-family: Roboto, sans-serif;
  line-height: 30.47px;
  letter-spacing: 5%;
  cursor: pointer;
  background-color: #E7E7E7;
  color: #303030;
  padding: 2px 10px;
  border-radius: 10px;
  margin-bottom: 5px;
`;

const StyledSpane = Styled.span`
  font-size: 14px;
  color: #808080;
  align-self: end;
  margin: 0;

`;

const CameraIcon = Styled.img`
    height: auto;
    width: 22px;
    margin-left: 10px;
    // position: absolute;
`;

const MicrophoneIcon = Styled.img`
  height: 35px;
  border-radius: 8px;
  padding: 5px;
  margin-left: 10px;
  background-color: #0EB4FB;
  cursor: pointer;
  `;

const StyledParagraph = Styled.p`
  justify-content:center;
  background-color: #E7E7E7; 
  font-size: 14px;
  fonweight: 400;
  font-family: Roboto, sans-serif;
  line-height: 30.47px;
  letter-spacing: 5%;
  cursor: pointer;
  color: #303030;
  padding: 2px 15px;
  border-radius: 10px;
  display: inline-block;
  text-align: center;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  align-items: center;
`;

const SwitcherContainer = Styled.div`
  display: flex;
  align-items: center;
`;

const Switcher = Styled.div`
  width: 45px;
  height: 21px;
  background-color: ${(props) => props.checked && 'white'};
  border-radius: 50px;
  position: relative;
  cursor: pointer;
  transition: background-color 0.3s ease;
  display: flex;
  justify-content: ${(props) => (props.checked ? 'flex-start' : 'flex-end')};
  align-items: center;
  padding: 0 4px;
  border: 1px solid #5D5FEF;
`;

const Toggle = Styled.div`
  width: 15px;
  height: 15px;
  background-color: #0EB4FB;
  border-radius: 50%;
  position: relative;
  transition: transform 0.3s ease, background-color 0.3s ease;
  // border: 1px solid #5D5FEF;
`;

const Label = Styled.span`
  font-size: 12px;
  font-weight: bold;
  color: black;
  position: absolute;
  left: ${(props) => (props.checked ? '25px' : '3px')};
  transition: left 0.3s ease;
`;

const VoiceWaveImage = Styled.img`
  height: 48px;
  width: 25%;

  @media (min-width: 1024px) {
    width: 7%;
  }
`;

export {
  CameraIcon,
  ConversationBox,
  ConversationContainer,
  ConversationWrapper,
  Heading,
  Label,
  MicrophoneIcon,
  StyledContainer,
  StyledInput,
  StyledNamearagraph,
  StyledParagraph,
  StyledReponseParagraph,
  StyledSpane,
  StyledStatusParagraph,
  Switcher,
  SwitcherContainer,
  Toggle, VoiceWaveImage
};

